const SOURCE = "sherpa-portal"

export function closeHostWidget(): void {
  if (window.parent === window) {
    return
  }

  let targetOrigin = "*"
  try {
    if (document.referrer) {
      targetOrigin = new URL(document.referrer).origin
    }
  } catch {
    targetOrigin = "*"
  }

  window.parent.postMessage({ source: SOURCE, type: "close" }, targetOrigin)
}
